/* parser generated by jison 0.4.18 */
/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/
var grammar = (function(){
var o=function(k,v,o,l){for(o=o||{},l=k.length;l--;o[k[l]]=v);return o},$V0=[10,16,28,29,42],$V1=[1,15],$V2=[10,16,28,29,33,42,47,52,63,68],$V3=[10,16,28,29,42,47,52,63,68],$V4=[1,42],$V5=[1,46],$V6=[1,38],$V7=[1,37],$V8=[1,39],$V9=[1,40],$Va=[1,41],$Vb=[1,43],$Vc=[1,44],$Vd=[1,56],$Ve=[1,57],$Vf=[1,58],$Vg=[10,16,24,28,29,42],$Vh=[10,16,22,24,28,29,42],$Vi=[1,63],$Vj=[1,64],$Vk=[1,65],$Vl=[1,66],$Vm=[1,67],$Vn=[1,68],$Vo=[1,69],$Vp=[1,70],$Vq=[1,71],$Vr=[1,72],$Vs=[1,73],$Vt=[1,74],$Vu=[1,75],$Vv=[8,10,16,18,24,28,29,33,36,40,42,47,52,59,62,63,67,68,72,73,74,75,76,77,78,79,80,81,82,83,84,87],$Vw=[2,87],$Vx=[8,10,16,18,24,28,29,33,36,40,42,47,52,59,62,63,67,68,69,72,73,74,75,76,77,78,79,80,81,82,83,84,87],$Vy=[10,29,47,52,63,68],$Vz=[1,86],$VA=[8,10,16,18,24,28,29,33,36,40,42,47,52,59,62,63,67,68,83,84,87],$VB=[2,51],$VC=[1,117],$VD=[10,29,40,47,52,59,62,63,68],$VE=[1,121],$VF=[8,18],$VG=[8,18,67],$VH=[10,16,28,29,36,42,47,52,63,68],$VI=[10,16,18,28,29,36,42,47,52,63,68],$VJ=[8,10,16,18,24,28,29,33,36,40,42,47,52,59,62,63,67,68,72,73,77,78,79,80,81,82,83,84,87],$VK=[8,10,16,18,24,28,29,33,36,40,42,47,52,59,62,63,67,68,77,78,79,80,81,82,83,84,87],$VL=[10,40,59],$VM=[8,10,16,18,28,29,36,42,47,52,63,67,68];
var parser = {trace: function trace () { },
yy: {},
symbols_: {"error":2,"file":3,"pattern":4,"EOF":5,"PATTERN":6,"STRING":7,"{":8,"pattern_body":9,"}":10,"pattern_decls":11,"param_decl":12,"counter_decl":13,"segment":14,"metadata_decl":15,"PARAM":16,"IDENT":17,":":18,"type_name":19,"optional_default":20,"optional_label":21,"=":22,"expr":23,"LABEL":24,"TYPE_INT":25,"TYPE_TEXT":26,"TYPE_BOOL":27,"METADATA":28,"COUNTER":29,"counter_init_opt":30,"links_opt":31,"COLON_EQ":32,"LINKS":33,"link_list":34,"link":35,",":36,"counter_ref":37,"link_when_opt":38,"link_delta_opt":39,"WHEN":40,"predicate":41,"SEGMENT":42,"segment_name":43,"segment_body":44,"steps":45,"SETUP":46,"BODY":47,"step":48,"row_step":49,"group_step":50,"note_step":51,"ROW":52,"row_instruction":53,"deltas_opt":54,"cases_body":55,"case_clauses":56,"else_clause_opt":57,"case_clause":58,"ELSE":59,"delta_clauses":60,"delta_clause":61,"DELTA":62,"REPEAT":63,"count":64,"as_opt":65,"UNTIL":66,"AS":67,"NOTE":68,"IS":69,"ODD":70,"EVEN":71,"+":72,"-":73,"*":74,"/":75,"%":76,"EQ":77,"NEQ":78,"LT":79,"LTE":80,"GT":81,"GTE":82,"AND":83,"OR":84,"NOT":85,"(":86,")":87,"MOD":88,"INT":89,"TRUE":90,"FALSE":91,".":92,"$accept":0,"$end":1},
terminals_: {2:"error",5:"EOF",6:"PATTERN",7:"STRING",8:"{",10:"}",16:"PARAM",17:"IDENT",18:":",22:"=",24:"LABEL",25:"TYPE_INT",26:"TYPE_TEXT",27:"TYPE_BOOL",28:"METADATA",29:"COUNTER",32:"COLON_EQ",33:"LINKS",36:",",40:"WHEN",42:"SEGMENT",46:"SETUP",47:"BODY",52:"ROW",59:"ELSE",62:"DELTA",63:"REPEAT",66:"UNTIL",67:"AS",68:"NOTE",69:"IS",70:"ODD",71:"EVEN",72:"+",73:"-",74:"*",75:"/",76:"%",77:"EQ",78:"NEQ",79:"LT",80:"LTE",81:"GT",82:"GTE",83:"AND",84:"OR",85:"NOT",86:"(",87:")",88:"MOD",89:"INT",90:"TRUE",91:"FALSE",92:"."},
productions_: [0,[3,2],[4,5],[9,1],[11,0],[11,2],[11,2],[11,2],[11,2],[12,6],[20,0],[20,2],[21,0],[21,2],[19,1],[19,1],[19,1],[15,4],[13,4],[13,4],[30,0],[30,2],[31,0],[31,3],[34,1],[34,3],[35,3],[38,0],[38,2],[39,0],[39,2],[14,5],[43,1],[43,1],[44,1],[44,6],[45,1],[45,2],[48,1],[48,1],[48,1],[48,1],[49,3],[53,1],[53,3],[55,2],[56,1],[56,2],[58,5],[57,0],[57,4],[54,0],[54,1],[60,1],[60,2],[61,4],[50,6],[50,5],[64,1],[64,2],[65,0],[65,2],[51,2],[41,1],[41,3],[41,3],[23,3],[23,3],[23,3],[23,3],[23,3],[23,3],[23,3],[23,3],[23,3],[23,3],[23,3],[23,3],[23,3],[23,2],[23,2],[23,3],[23,6],[23,1],[23,1],[23,1],[23,1],[23,1],[37,1],[37,3]],
performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
/* this == yyval */

var $0 = $$.length - 1;
switch (yystate) {
case 1:
 return $$[$0-1]; 
break;
case 2:

          this.$ = {
            ir_version: "1.0",
            kind: "pattern",
            id: yy.id(),
            name: yy.unquote($$[$0-3]),
            params:   $$[$0-1].params,
            counters: $$[$0-1].counters,
            segments: $$[$0-1].segments
          };
          if (Object.keys($$[$0-1].metadata).length > 0) {
            this.$.metadata = $$[$0-1].metadata;
          }
        
break;
case 3: case 11: case 21: case 23: case 28: case 30: case 32: case 52: case 61: case 63: case 87:
 this.$ = $$[$0]; 
break;
case 4:
 this.$ = { params: [], counters: [], segments: [], metadata: {} }; 
break;
case 5:
 $$[$0-1].params.push($$[$0]); this.$ = $$[$0-1]; 
break;
case 6:
 $$[$0-1].counters.push($$[$0]); this.$ = $$[$0-1]; 
break;
case 7:
 $$[$0-1].segments.push($$[$0]); this.$ = $$[$0-1]; 
break;
case 8:

          if (Object.prototype.hasOwnProperty.call($$[$0-1].metadata, $$[$0].key)) {
            throw new Error("Duplicate metadata key: " + $$[$0].key);
          }
          $$[$0-1].metadata[$$[$0].key] = $$[$0].value;
          this.$ = $$[$0-1];
        
break;
case 9:

          this.$ = {
            kind: "param", id: yy.id(), name: $$[$0-4], type: $$[$0-2],
            default: $$[$0-1] !== null ? $$[$0-1] : yy.defaultFor($$[$0-2]),
            ...($$[$0] !== null ? { label: $$[$0] } : {})
          };
        
break;
case 10: case 12: case 20: case 27: case 29: case 49: case 60:
 this.$ = null; 
break;
case 13: case 33:
 this.$ = yy.unquote($$[$0]); 
break;
case 14:
 this.$ = "int"; 
break;
case 15:
 this.$ = "text"; 
break;
case 16:
 this.$ = "bool"; 
break;
case 17:
 this.$ = { key: $$[$0-2], value: yy.unquote($$[$0]) }; 
break;
case 18:

          this.$ = {
            kind: "counter_mutable", id: yy.id(), name: $$[$0-2],
            init: $$[$0-1] || { kind: "literal", type: "int", value: 0 },
            links: $$[$0]
          };
        
break;
case 19:

          this.$ = {
            kind: "counter_derived", id: yy.id(), name: $$[$0-2], expr: $$[$0]
          };
        
break;
case 22: case 51:
 this.$ = []; 
break;
case 24: case 36: case 46: case 53:
 this.$ = [$$[$0]]; 
break;
case 25:
 $$[$0-2].push($$[$0]); this.$ = $$[$0-2]; 
break;
case 26:

          this.$ = {
            kind: "link",
            source: $$[$0-2],
            when: $$[$0-1],
            delta: $$[$0] || { kind: "literal", type: "int", value: 1 }
          };
        
break;
case 31:

          this.$ = {
            kind: "segment", id: yy.id(), name: $$[$0-3],
            counters: $$[$0-1].counters,
            setup:    $$[$0-1].setup,
            body:     $$[$0-1].body
          };
        
break;
case 34:

          var partitioned = yy.splitInlineCounters($$[$0]);
          this.$ = { counters: partitioned.counters, setup: [], body: partitioned.body };
        
break;
case 35:

          var partitionedSetup = yy.splitInlineCounters($$[$0-3]);
          var partitionedBody = yy.splitInlineCounters($$[$0]);
          this.$ = {
            counters: partitionedSetup.counters.concat(partitionedBody.counters),
            setup:    partitionedSetup.body,
            body:     partitionedBody.body
          };
        
break;
case 37: case 47: case 54:
 $$[$0-1].push($$[$0]); this.$ = $$[$0-1]; 
break;
case 41:
 this.$ = { kind: "_inline_counter", decl: $$[$0] }; 
break;
case 42: case 50:

          this.$ = {
            kind: "row", id: yy.id(),
            instruction: $$[$0-1],
            deltas: $$[$0]
          };
        
break;
case 43:
 this.$ = { kind: "instruction_text", expr: $$[$0] }; 
break;
case 44: case 81:
 this.$ = $$[$0-1]; 
break;
case 45:

          this.$ = {
            kind: "instruction_cases",
            cases: $$[$0-1],
            else: $$[$0]
          };
        
break;
case 48:

          this.$ = {
            when: $$[$0-3],
            row: {
              kind: "row", id: yy.id(),
              instruction: $$[$0-1],
              deltas: $$[$0]
            }
          };
        
break;
case 55:

          this.$ = {
            kind: "delta",
            target: $$[$0-2],
            expr: $$[$0]
          };
        
break;
case 56:

          var partitioned = yy.splitInlineCounters($$[$0-1]);
          this.$ = {
            kind: "group", id: yy.id(),
            iter_name: $$[$0-3],
            count: $$[$0-4],
            counters: partitioned.counters,
            body:     partitioned.body
          };
        
break;
case 57:

          /* Single-step body sugar. The single step cannot itself be a
             counter declaration (no place for it). */
          if ($$[$0].kind === "_inline_counter") {
            throw new Error("Cannot place counter declaration in single-step repeat");
          }
          this.$ = {
            kind: "group", id: yy.id(),
            iter_name: $$[$0-2],
            count: $$[$0-3],
            counters: [],
            body: [$$[$0]]
          };
        
break;
case 58:
 this.$ = { kind: "count_fixed", expr: $$[$0] }; 
break;
case 59:
 this.$ = { kind: "_count_until_ambiguous", expr: $$[$0] }; 
break;
case 62:
 this.$ = { kind: "note", id: yy.id(), text_expr: $$[$0] }; 
break;
case 64:

          this.$ = {
            kind: "binop", op: "==",
            left: {
              kind: "binop", op: "%",
              left:  $$[$0-2],
              right: { kind: "literal", type: "int", value: 2 }
            },
            right: { kind: "literal", type: "int", value: 1 }
          };
        
break;
case 65:

          this.$ = {
            kind: "binop", op: "==",
            left: {
              kind: "binop", op: "%",
              left:  $$[$0-2],
              right: { kind: "literal", type: "int", value: 2 }
            },
            right: { kind: "literal", type: "int", value: 0 }
          };
        
break;
case 66:
 this.$ = yy.bin("+",  $$[$0-2], $$[$0]); 
break;
case 67:
 this.$ = yy.bin("-",  $$[$0-2], $$[$0]); 
break;
case 68:
 this.$ = yy.bin("*",  $$[$0-2], $$[$0]); 
break;
case 69:
 this.$ = yy.bin("/",  $$[$0-2], $$[$0]); 
break;
case 70:
 this.$ = yy.bin("%",  $$[$0-2], $$[$0]); 
break;
case 71:
 this.$ = yy.bin("==", $$[$0-2], $$[$0]); 
break;
case 72:
 this.$ = yy.bin("!=", $$[$0-2], $$[$0]); 
break;
case 73:
 this.$ = yy.bin("<",  $$[$0-2], $$[$0]); 
break;
case 74:
 this.$ = yy.bin("<=", $$[$0-2], $$[$0]); 
break;
case 75:
 this.$ = yy.bin(">",  $$[$0-2], $$[$0]); 
break;
case 76:
 this.$ = yy.bin(">=", $$[$0-2], $$[$0]); 
break;
case 77:
 this.$ = yy.bin("and", $$[$0-2], $$[$0]); 
break;
case 78:
 this.$ = yy.bin("or",  $$[$0-2], $$[$0]); 
break;
case 79:
 this.$ = { kind: "unop", op: "not", operand: $$[$0] }; 
break;
case 80:
 this.$ = { kind: "unop", op: "neg", operand: $$[$0] }; 
break;
case 82:
 this.$ = yy.bin("%", $$[$0-3], $$[$0-1]); 
break;
case 83:
 this.$ = { kind: "literal", type: "int", value: parseInt($$[$0], 10) }; 
break;
case 84:
 this.$ = { kind: "literal", type: "text", value: yy.unquote($$[$0]) }; 
break;
case 85:
 this.$ = { kind: "literal", type: "bool", value: true }; 
break;
case 86:
 this.$ = { kind: "literal", type: "bool", value: false }; 
break;
case 88:
 this.$ = { kind: "counter_ref", name: $$[$0] }; 
break;
case 89:
 this.$ = { kind: "counter_ref", name: $$[$0-2] + "." + $$[$0] }; 
break;
}
},
table: [{3:1,4:2,6:[1,3]},{1:[3]},{5:[1,4]},{7:[1,5]},{1:[2,1]},{8:[1,6]},o($V0,[2,4],{9:7,11:8}),{10:[1,9]},{10:[2,3],12:10,13:11,14:12,15:13,16:[1,14],28:[1,17],29:$V1,42:[1,16]},{5:[2,2]},o($V0,[2,5]),o($V0,[2,6]),o($V0,[2,7]),o($V0,[2,8]),{17:[1,18]},{17:[1,19]},{7:[1,22],17:[1,21],43:20},{17:[1,23]},{18:[1,24]},o($V2,[2,20],{30:25,22:[1,27],32:[1,26]}),{8:[1,28]},{8:[2,32]},{8:[2,33]},{22:[1,29]},{19:30,25:[1,31],26:[1,32],27:[1,33]},o($V3,[2,22],{31:34,33:[1,35]}),{7:$V4,17:$V5,23:36,37:45,73:$V6,85:$V7,86:$V8,88:$V9,89:$Va,90:$Vb,91:$Vc},{7:$V4,17:$V5,23:47,37:45,73:$V6,85:$V7,86:$V8,88:$V9,89:$Va,90:$Vb,91:$Vc},{13:55,29:$V1,44:48,45:49,46:[1,50],48:51,49:52,50:53,51:54,52:$Vd,63:$Ve,68:$Vf},{7:[1,59]},o($Vg,[2,10],{20:60,22:[1,61]}),o($Vh,[2,14]),o($Vh,[2,15]),o($Vh,[2,16]),o($V3,[2,18]),{18:[1,62]},o($V3,[2,19],{72:$Vi,73:$Vj,74:$Vk,75:$Vl,76:$Vm,77:$Vn,78:$Vo,79:$Vp,80:$Vq,81:$Vr,82:$Vs,83:$Vt,84:$Vu}),{7:$V4,17:$V5,23:76,37:45,73:$V6,85:$V7,86:$V8,88:$V9,89:$Va,90:$Vb,91:$Vc},{7:$V4,17:$V5,23:77,37:45,73:$V6,85:$V7,86:$V8,88:$V9,89:$Va,90:$Vb,91:$Vc},{7:$V4,17:$V5,23:78,37:45,73:$V6,85:$V7,86:$V8,88:$V9,89:$Va,90:$Vb,91:$Vc},{86:[1,79]},o($Vv,[2,83]),o($Vv,[2,84]),o($Vv,[2,85]),o($Vv,[2,86]),o($Vv,$Vw),o($Vx,[2,88],{92:[1,80]}),o($V2,[2,21],{72:$Vi,73:$Vj,74:$Vk,75:$Vl,76:$Vm,77:$Vn,78:$Vo,79:$Vp,80:$Vq,81:$Vr,82:$Vs,83:$Vt,84:$Vu}),{10:[1,81]},{10:[2,34],13:55,29:$V1,48:82,49:52,50:53,51:54,52:$Vd,63:$Ve,68:$Vf},{18:[1,83]},o($Vy,[2,36]),o($Vy,[2,38]),o($Vy,[2,39]),o($Vy,[2,40]),o($Vy,[2,41]),{7:$V4,8:$Vz,17:$V5,23:85,37:45,53:84,73:$V6,85:$V7,86:$V8,88:$V9,89:$Va,90:$Vb,91:$Vc},{7:$V4,17:$V5,23:88,37:45,64:87,66:[1,89],73:$V6,85:$V7,86:$V8,88:$V9,89:$Va,90:$Vb,91:$Vc},{7:$V4,17:$V5,23:90,37:45,73:$V6,85:$V7,86:$V8,88:$V9,89:$Va,90:$Vb,91:$Vc},o($V0,[2,17]),o($V0,[2,12],{21:91,24:[1,92]}),{7:$V4,17:$V5,23:93,37:45,73:$V6,85:$V7,86:$V8,88:$V9,89:$Va,90:$Vb,91:$Vc},{17:$V5,34:94,35:95,37:96},{7:$V4,17:$V5,23:97,37:45,73:$V6,85:$V7,86:$V8,88:$V9,89:$Va,90:$Vb,91:$Vc},{7:$V4,17:$V5,23:98,37:45,73:$V6,85:$V7,86:$V8,88:$V9,89:$Va,90:$Vb,91:$Vc},{7:$V4,17:$V5,23:99,37:45,73:$V6,85:$V7,86:$V8,88:$V9,89:$Va,90:$Vb,91:$Vc},{7:$V4,17:$V5,23:100,37:45,73:$V6,85:$V7,86:$V8,88:$V9,89:$Va,90:$Vb,91:$Vc},{7:$V4,17:$V5,23:101,37:45,73:$V6,85:$V7,86:$V8,88:$V9,89:$Va,90:$Vb,91:$Vc},{7:$V4,17:$V5,23:102,37:45,73:$V6,85:$V7,86:$V8,88:$V9,89:$Va,90:$Vb,91:$Vc},{7:$V4,17:$V5,23:103,37:45,73:$V6,85:$V7,86:$V8,88:$V9,89:$Va,90:$Vb,91:$Vc},{7:$V4,17:$V5,23:104,37:45,73:$V6,85:$V7,86:$V8,88:$V9,89:$Va,90:$Vb,91:$Vc},{7:$V4,17:$V5,23:105,37:45,73:$V6,85:$V7,86:$V8,88:$V9,89:$Va,90:$Vb,91:$Vc},{7:$V4,17:$V5,23:106,37:45,73:$V6,85:$V7,86:$V8,88:$V9,89:$Va,90:$Vb,91:$Vc},{7:$V4,17:$V5,23:107,37:45,73:$V6,85:$V7,86:$V8,88:$V9,89:$Va,90:$Vb,91:$Vc},{7:$V4,17:$V5,23:108,37:45,73:$V6,85:$V7,86:$V8,88:$V9,89:$Va,90:$Vb,91:$Vc},{7:$V4,17:$V5,23:109,37:45,73:$V6,85:$V7,86:$V8,88:$V9,89:$Va,90:$Vb,91:$Vc},o($VA,[2,79],{72:$Vi,73:$Vj,74:$Vk,75:$Vl,76:$Vm,77:$Vn,78:$Vo,79:$Vp,80:$Vq,81:$Vr,82:$Vs}),o($Vv,[2,80]),{72:$Vi,73:$Vj,74:$Vk,75:$Vl,76:$Vm,77:$Vn,78:$Vo,79:$Vp,80:$Vq,81:$Vr,82:$Vs,83:$Vt,84:$Vu,87:[1,110]},{7:$V4,17:$V5,23:111,37:45,73:$V6,85:$V7,86:$V8,88:$V9,89:$Va,90:$Vb,91:$Vc},{17:[1,112]},o($V0,[2,31]),o($Vy,[2,37]),{13:55,29:$V1,45:113,48:51,49:52,50:53,51:54,52:$Vd,63:$Ve,68:$Vf},o($Vy,$VB,{54:114,60:115,61:116,62:$VC}),o($VD,[2,43],{72:$Vi,73:$Vj,74:$Vk,75:$Vl,76:$Vm,77:$Vn,78:$Vo,79:$Vp,80:$Vq,81:$Vr,82:$Vs,83:$Vt,84:$Vu}),{40:$VE,55:118,56:119,58:120},o($VF,[2,60],{65:122,67:[1,123]}),o($VG,[2,58],{72:$Vi,73:$Vj,74:$Vk,75:$Vl,76:$Vm,77:$Vn,78:$Vo,79:$Vp,80:$Vq,81:$Vr,82:$Vs,83:$Vt,84:$Vu}),{7:$V4,17:$V5,23:125,37:126,41:124,73:$V6,85:$V7,86:$V8,88:$V9,89:$Va,90:$Vb,91:$Vc},o($Vy,[2,62],{72:$Vi,73:$Vj,74:$Vk,75:$Vl,76:$Vm,77:$Vn,78:$Vo,79:$Vp,80:$Vq,81:$Vr,82:$Vs,83:$Vt,84:$Vu}),o($V0,[2,9]),{7:[1,127]},o($Vg,[2,11],{72:$Vi,73:$Vj,74:$Vk,75:$Vl,76:$Vm,77:$Vn,78:$Vo,79:$Vp,80:$Vq,81:$Vr,82:$Vs,83:$Vt,84:$Vu}),o($V3,[2,23],{36:[1,128]}),o($VH,[2,24]),o($VI,[2,27],{38:129,40:[1,130]}),o($VJ,[2,66],{74:$Vk,75:$Vl,76:$Vm}),o($VJ,[2,67],{74:$Vk,75:$Vl,76:$Vm}),o($Vv,[2,68]),o($Vv,[2,69]),o($Vv,[2,70]),o($VK,[2,71],{72:$Vi,73:$Vj,74:$Vk,75:$Vl,76:$Vm}),o($VK,[2,72],{72:$Vi,73:$Vj,74:$Vk,75:$Vl,76:$Vm}),o($VK,[2,73],{72:$Vi,73:$Vj,74:$Vk,75:$Vl,76:$Vm}),o($VK,[2,74],{72:$Vi,73:$Vj,74:$Vk,75:$Vl,76:$Vm}),o($VK,[2,75],{72:$Vi,73:$Vj,74:$Vk,75:$Vl,76:$Vm}),o($VK,[2,76],{72:$Vi,73:$Vj,74:$Vk,75:$Vl,76:$Vm}),o($VA,[2,77],{72:$Vi,73:$Vj,74:$Vk,75:$Vl,76:$Vm,77:$Vn,78:$Vo,79:$Vp,80:$Vq,81:$Vr,82:$Vs}),o([8,10,16,18,24,28,29,33,36,40,42,47,52,59,62,63,67,68,84,87],[2,78],{72:$Vi,73:$Vj,74:$Vk,75:$Vl,76:$Vm,77:$Vn,78:$Vo,79:$Vp,80:$Vq,81:$Vr,82:$Vs,83:$Vt}),o($Vv,[2,81]),{36:[1,131],72:$Vi,73:$Vj,74:$Vk,75:$Vl,76:$Vm,77:$Vn,78:$Vo,79:$Vp,80:$Vq,81:$Vr,82:$Vs,83:$Vt,84:$Vu},o($Vx,[2,89]),{13:55,29:$V1,47:[1,132],48:82,49:52,50:53,51:54,52:$Vd,63:$Ve,68:$Vf},o($Vy,[2,42]),o([10,29,40,47,52,59,63,68],[2,52],{61:133,62:$VC}),o($VD,[2,53]),{17:$V5,37:134},{10:[1,135]},{10:[2,49],40:$VE,57:136,58:137,59:[1,138]},o($VL,[2,46]),{7:$V4,17:$V5,23:125,37:126,41:139,73:$V6,85:$V7,86:$V8,88:$V9,89:$Va,90:$Vb,91:$Vc},{8:[1,140],18:[1,141]},{17:[1,142]},o($VG,[2,59]),o($VM,[2,63],{72:$Vi,73:$Vj,74:$Vk,75:$Vl,76:$Vm,77:$Vn,78:$Vo,79:$Vp,80:$Vq,81:$Vr,82:$Vs,83:$Vt,84:$Vu}),o([8,10,16,18,28,29,36,42,47,52,63,67,68,72,73,74,75,76,77,78,79,80,81,82,83,84],$Vw,{69:[1,143]}),o($V0,[2,13]),{17:$V5,35:144,37:96},o($VH,[2,29],{39:145,18:[1,146]}),{7:$V4,17:$V5,23:125,37:126,41:147,73:$V6,85:$V7,86:$V8,88:$V9,89:$Va,90:$Vb,91:$Vc},{7:$V4,17:$V5,23:148,37:45,73:$V6,85:$V7,86:$V8,88:$V9,89:$Va,90:$Vb,91:$Vc},{18:[1,149]},o($VD,[2,54]),{18:[1,150]},o($VD,[2,44]),{10:[2,45]},o($VL,[2,47]),{18:[1,151]},{18:[1,152]},{13:55,29:$V1,45:153,48:51,49:52,50:53,51:54,52:$Vd,63:$Ve,68:$Vf},{13:55,29:$V1,48:154,49:52,50:53,51:54,52:$Vd,63:$Ve,68:$Vf},o($VF,[2,61]),{70:[1,155],71:[1,156]},o($VH,[2,25]),o($VH,[2,26]),{7:$V4,17:$V5,23:157,37:45,73:$V6,85:$V7,86:$V8,88:$V9,89:$Va,90:$Vb,91:$Vc},o($VI,[2,28]),{72:$Vi,73:$Vj,74:$Vk,75:$Vl,76:$Vm,77:$Vn,78:$Vo,79:$Vp,80:$Vq,81:$Vr,82:$Vs,83:$Vt,84:$Vu,87:[1,158]},{13:55,29:$V1,45:159,48:51,49:52,50:53,51:54,52:$Vd,63:$Ve,68:$Vf},{7:$V4,17:$V5,23:160,37:45,73:$V6,85:$V7,86:$V8,88:$V9,89:$Va,90:$Vb,91:$Vc},{7:$V4,8:$Vz,17:$V5,23:85,37:45,53:161,73:$V6,85:$V7,86:$V8,88:$V9,89:$Va,90:$Vb,91:$Vc},{7:$V4,8:$Vz,17:$V5,23:85,37:45,53:162,73:$V6,85:$V7,86:$V8,88:$V9,89:$Va,90:$Vb,91:$Vc},{10:[1,163],13:55,29:$V1,48:82,49:52,50:53,51:54,52:$Vd,63:$Ve,68:$Vf},o($Vy,[2,57]),o($VM,[2,64]),o($VM,[2,65]),o($VH,[2,30],{72:$Vi,73:$Vj,74:$Vk,75:$Vl,76:$Vm,77:$Vn,78:$Vo,79:$Vp,80:$Vq,81:$Vr,82:$Vs,83:$Vt,84:$Vu}),o($Vv,[2,82]),{10:[2,35],13:55,29:$V1,48:82,49:52,50:53,51:54,52:$Vd,63:$Ve,68:$Vf},o($VD,[2,55],{72:$Vi,73:$Vj,74:$Vk,75:$Vl,76:$Vm,77:$Vn,78:$Vo,79:$Vp,80:$Vq,81:$Vr,82:$Vs,83:$Vt,84:$Vu}),{10:$VB,54:164,60:115,61:116,62:$VC},o($VL,$VB,{60:115,61:116,54:165,62:$VC}),o($Vy,[2,56]),{10:[2,50]},o($VL,[2,48])],
defaultActions: {4:[2,1],9:[2,2],21:[2,32],22:[2,33],136:[2,45],164:[2,50]},
parseError: function parseError (str, hash) {
    if (hash.recoverable) {
        this.trace(str);
    } else {
        var error = new Error(str);
        error.hash = hash;
        throw error;
    }
},
parse: function parse(input) {
    var self = this, stack = [0], tstack = [], vstack = [null], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
    var args = lstack.slice.call(arguments, 1);
    var lexer = Object.create(this.lexer);
    var sharedState = { yy: {} };
    for (var k in this.yy) {
        if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
            sharedState.yy[k] = this.yy[k];
        }
    }
    lexer.setInput(input, sharedState.yy);
    sharedState.yy.lexer = lexer;
    sharedState.yy.parser = this;
    if (typeof lexer.yylloc == 'undefined') {
        lexer.yylloc = {};
    }
    var yyloc = lexer.yylloc;
    lstack.push(yyloc);
    var ranges = lexer.options && lexer.options.ranges;
    if (typeof sharedState.yy.parseError === 'function') {
        this.parseError = sharedState.yy.parseError;
    } else {
        this.parseError = Object.getPrototypeOf(this).parseError;
    }
    function popStack(n) {
        stack.length = stack.length - 2 * n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
    }
    _token_stack:
        var lex = function () {
            var token;
            token = lexer.lex() || EOF;
            if (typeof token !== 'number') {
                token = self.symbols_[token] || token;
            }
            return token;
        };
    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
    while (true) {
        state = stack[stack.length - 1];
        if (this.defaultActions[state]) {
            action = this.defaultActions[state];
        } else {
            if (symbol === null || typeof symbol == 'undefined') {
                symbol = lex();
            }
            action = table[state] && table[state][symbol];
        }
                    if (typeof action === 'undefined' || !action.length || !action[0]) {
                var errStr = '';
                expected = [];
                for (p in table[state]) {
                    if (this.terminals_[p] && p > TERROR) {
                        expected.push('\'' + this.terminals_[p] + '\'');
                    }
                }
                if (lexer.showPosition) {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
                } else {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
                }
                this.parseError(errStr, {
                    text: lexer.match,
                    token: this.terminals_[symbol] || symbol,
                    line: lexer.yylineno,
                    loc: yyloc,
                    expected: expected
                });
            }
        if (action[0] instanceof Array && action.length > 1) {
            throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
        }
        switch (action[0]) {
        case 1:
            stack.push(symbol);
            vstack.push(lexer.yytext);
            lstack.push(lexer.yylloc);
            stack.push(action[1]);
            symbol = null;
            if (!preErrorSymbol) {
                yyleng = lexer.yyleng;
                yytext = lexer.yytext;
                yylineno = lexer.yylineno;
                yyloc = lexer.yylloc;
                if (recovering > 0) {
                    recovering--;
                }
            } else {
                symbol = preErrorSymbol;
                preErrorSymbol = null;
            }
            break;
        case 2:
            len = this.productions_[action[1]][1];
            yyval.$ = vstack[vstack.length - len];
            yyval._$ = {
                first_line: lstack[lstack.length - (len || 1)].first_line,
                last_line: lstack[lstack.length - 1].last_line,
                first_column: lstack[lstack.length - (len || 1)].first_column,
                last_column: lstack[lstack.length - 1].last_column
            };
            if (ranges) {
                yyval._$.range = [
                    lstack[lstack.length - (len || 1)].range[0],
                    lstack[lstack.length - 1].range[1]
                ];
            }
            r = this.performAction.apply(yyval, [
                yytext,
                yyleng,
                yylineno,
                sharedState.yy,
                action[1],
                vstack,
                lstack
            ].concat(args));
            if (typeof r !== 'undefined') {
                return r;
            }
            if (len) {
                stack = stack.slice(0, -1 * len * 2);
                vstack = vstack.slice(0, -1 * len);
                lstack = lstack.slice(0, -1 * len);
            }
            stack.push(this.productions_[action[1]][0]);
            vstack.push(yyval.$);
            lstack.push(yyval._$);
            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
            stack.push(newState);
            break;
        case 3:
            return true;
        }
    }
    return true;
}};
/* generated by jison-lex 0.3.4 */
var lexer = (function(){
var lexer = ({

EOF:1,

parseError:function parseError(str, hash) {
        if (this.yy.parser) {
            this.yy.parser.parseError(str, hash);
        } else {
            throw new Error(str);
        }
    },

// resets the lexer, sets new input
setInput:function (input, yy) {
        this.yy = yy || this.yy || {};
        this._input = input;
        this._more = this._backtrack = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
        };
        if (this.options.ranges) {
            this.yylloc.range = [0,0];
        }
        this.offset = 0;
        return this;
    },

// consumes and returns one char from the input
input:function () {
        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch;
        var lines = ch.match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno++;
            this.yylloc.last_line++;
        } else {
            this.yylloc.last_column++;
        }
        if (this.options.ranges) {
            this.yylloc.range[1]++;
        }

        this._input = this._input.slice(1);
        return ch;
    },

// unshifts one char (or a string) into the input
unput:function (ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);

        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length - len);
        //this.yyleng -= len;
        this.offset -= len;
        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length - 1);
        this.matched = this.matched.substr(0, this.matched.length - 1);

        if (lines.length - 1) {
            this.yylineno -= lines.length - 1;
        }
        var r = this.yylloc.range;

        this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: lines ?
                (lines.length === oldLines.length ? this.yylloc.first_column : 0)
                 + oldLines[oldLines.length - lines.length].length - lines[0].length :
              this.yylloc.first_column - len
        };

        if (this.options.ranges) {
            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
        }
        this.yyleng = this.yytext.length;
        return this;
    },

// When called from action, caches matched text and appends it on next action
more:function () {
        this._more = true;
        return this;
    },

// When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
reject:function () {
        if (this.options.backtrack_lexer) {
            this._backtrack = true;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });

        }
        return this;
    },

// retain first n characters of the match
less:function (n) {
        this.unput(this.match.slice(n));
    },

// displays already matched input, i.e. for error messages
pastInput:function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
    },

// displays upcoming input, i.e. for error messages
upcomingInput:function () {
        var next = this.match;
        if (next.length < 20) {
            next += this._input.substr(0, 20-next.length);
        }
        return (next.substr(0,20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
    },

// displays the character position where the lexing error occurred, i.e. for error messages
showPosition:function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c + "^";
    },

// test the lexed token: return FALSE when not a match, otherwise return token
test_match:function(match, indexed_rule) {
        var token,
            lines,
            backup;

        if (this.options.backtrack_lexer) {
            // save context
            backup = {
                yylineno: this.yylineno,
                yylloc: {
                    first_line: this.yylloc.first_line,
                    last_line: this.last_line,
                    first_column: this.yylloc.first_column,
                    last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
            };
            if (this.options.ranges) {
                backup.yylloc.range = this.yylloc.range.slice(0);
            }
        }

        lines = match[0].match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno += lines.length;
        }
        this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: lines ?
                         lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
                         this.yylloc.last_column + match[0].length
        };
        this.yytext += match[0];
        this.match += match[0];
        this.matches = match;
        this.yyleng = this.yytext.length;
        if (this.options.ranges) {
            this.yylloc.range = [this.offset, this.offset += this.yyleng];
        }
        this._more = false;
        this._backtrack = false;
        this._input = this._input.slice(match[0].length);
        this.matched += match[0];
        token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
        if (this.done && this._input) {
            this.done = false;
        }
        if (token) {
            return token;
        } else if (this._backtrack) {
            // recover context
            for (var k in backup) {
                this[k] = backup[k];
            }
            return false; // rule action called reject() implying the next rule should be tested instead.
        }
        return false;
    },

// return next match in input
next:function () {
        if (this.done) {
            return this.EOF;
        }
        if (!this._input) {
            this.done = true;
        }

        var token,
            match,
            tempMatch,
            index;
        if (!this._more) {
            this.yytext = '';
            this.match = '';
        }
        var rules = this._currentRules();
        for (var i = 0; i < rules.length; i++) {
            tempMatch = this._input.match(this.rules[rules[i]]);
            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                match = tempMatch;
                index = i;
                if (this.options.backtrack_lexer) {
                    token = this.test_match(tempMatch, rules[i]);
                    if (token !== false) {
                        return token;
                    } else if (this._backtrack) {
                        match = false;
                        continue; // rule action called reject() implying a rule MISmatch.
                    } else {
                        // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                        return false;
                    }
                } else if (!this.options.flex) {
                    break;
                }
            }
        }
        if (match) {
            token = this.test_match(match, rules[index]);
            if (token !== false) {
                return token;
            }
            // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
            return false;
        }
        if (this._input === "") {
            return this.EOF;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });
        }
    },

// return next match that has a token
lex:function lex () {
        var r = this.next();
        if (r) {
            return r;
        } else {
            return this.lex();
        }
    },

// activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
begin:function begin (condition) {
        this.conditionStack.push(condition);
    },

// pop the previously active lexer condition state off the condition stack
popState:function popState () {
        var n = this.conditionStack.length - 1;
        if (n > 0) {
            return this.conditionStack.pop();
        } else {
            return this.conditionStack[0];
        }
    },

// produce the lexer rule set which is active for the currently active lexer condition state
_currentRules:function _currentRules () {
        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
        } else {
            return this.conditions["INITIAL"].rules;
        }
    },

// return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
topState:function topState (n) {
        n = this.conditionStack.length - 1 - Math.abs(n || 0);
        if (n >= 0) {
            return this.conditionStack[n];
        } else {
            return "INITIAL";
        }
    },

// alias for begin(condition)
pushState:function pushState (condition) {
        this.begin(condition);
    },

// return the number of states currently on the stack
stateStackSize:function stateStackSize() {
        return this.conditionStack.length;
    },
options: {"case-insensitive":true},
performAction: function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {
var YYSTATE=YY_START;
switch($avoiding_name_collisions) {
case 0:/* skip whitespace */
break;
case 1:/* skip line comments */
break;
case 2:/* skip block comments */
break;
case 3:return 7;
break;
case 4:return 89;
break;
case 5:return 6;
break;
case 6:return 16;
break;
case 7:return 29;
break;
case 8:return 42;
break;
case 9:return 46;
break;
case 10:return 52;
break;
case 11:return 68;
break;
case 12:return 63;
break;
case 13:return 66;
break;
case 14:return 67;
break;
case 15:return 47;
break;
case 16:return 33;
break;
case 17:return 28;
break;
case 18:return 62;
break;
case 19:return 40;
break;
case 20:return 59;
break;
case 21:return 69;
break;
case 22:return 70;
break;
case 23:return 71;
break;
case 24:return 88;
break;
case 25:return 83;
break;
case 26:return 84;
break;
case 27:return 85;
break;
case 28:return 24;
break;
case 29:return 90;
break;
case 30:return 91;
break;
case 31:return 25;
break;
case 32:return 26;
break;
case 33:return 27;
break;
case 34:return 17;
break;
case 35:return 32;
break;
case 36:return 77;
break;
case 37:return 78;
break;
case 38:return 80;
break;
case 39:return 82;
break;
case 40:return 79;
break;
case 41:return 81;
break;
case 42:return 22;
break;
case 43:return 72;
break;
case 44:return 73;
break;
case 45:return 74;
break;
case 46:return 75;
break;
case 47:return 76;
break;
case 48:return 86;
break;
case 49:return 87;
break;
case 50:return 8;
break;
case 51:return 10;
break;
case 52:return 36;
break;
case 53:return 18;
break;
case 54:return 92;
break;
case 55:return 5;
break;
case 56:return 'INVALID';
break;
}
},
rules: [/^(?:\s+)/i,/^(?:\/\/.*)/i,/^(?:\/\*([^*]|\*+[^*/])*\*+\/)/i,/^(?:"([^\"\\]|\\.)*")/i,/^(?:[0-9]+)/i,/^(?:pattern\b)/i,/^(?:param\b)/i,/^(?:counter\b)/i,/^(?:segment\b)/i,/^(?:setup\b)/i,/^(?:row\b)/i,/^(?:note\b)/i,/^(?:repeat\b)/i,/^(?:until\b)/i,/^(?:as\b)/i,/^(?:body\b)/i,/^(?:links\b)/i,/^(?:metadata\b)/i,/^(?:delta\b)/i,/^(?:when\b)/i,/^(?:else\b)/i,/^(?:is\b)/i,/^(?:odd\b)/i,/^(?:even\b)/i,/^(?:mod\b)/i,/^(?:and\b)/i,/^(?:or\b)/i,/^(?:not\b)/i,/^(?:label\b)/i,/^(?:true\b)/i,/^(?:false\b)/i,/^(?:int\b)/i,/^(?:text\b)/i,/^(?:bool\b)/i,/^(?:[a-zA-Z_][a-zA-Z0-9_]*)/i,/^(?::=)/i,/^(?:==)/i,/^(?:!=)/i,/^(?:<=)/i,/^(?:>=)/i,/^(?:<)/i,/^(?:>)/i,/^(?:=)/i,/^(?:\+)/i,/^(?:-)/i,/^(?:\*)/i,/^(?:\/)/i,/^(?:%)/i,/^(?:\()/i,/^(?:\))/i,/^(?:\{)/i,/^(?:\})/i,/^(?:,)/i,/^(?::)/i,/^(?:\.)/i,/^(?:$)/i,/^(?:.)/i],
conditions: {"INITIAL":{"rules":[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56],"inclusive":true}}
});
return lexer;
})();
parser.lexer = lexer;
function Parser () {
  this.yy = {};
}
Parser.prototype = parser;parser.Parser = Parser;
return new Parser;
})();


if (typeof require !== 'undefined' && typeof exports !== 'undefined') {
exports.parser = grammar;
exports.Parser = grammar.Parser;
exports.parse = function () { return grammar.parse.apply(grammar, arguments); };
exports.main = function commonjsMain (args) {
    if (!args[1]) {
        console.log('Usage: '+args[0]+' FILE');
        process.exit(1);
    }
    var source = require('fs').readFileSync(require('path').normalize(args[1]), "utf8");
    return exports.parser.parse(source);
};
if (typeof module !== 'undefined' && require.main === module) {
  exports.main(process.argv.slice(1));
}
}
export const parser = grammar;
